import gql from 'graphql-tag';

import albumFolderDetails from './albumFolderDetails';
import albumFolderPricing from './albumFolderPricing';
import albumFolderCustomTags from './albumFolderCustomTags';
import albumCustomPrintDetails from './albumCustomPrintDetails';
import albumMembershipGroupPhotoPricing from './albumMembershipGroupPhotoPricing';
import albumMembershipGroupPrintPackages from './albumMembershipGroupPrintPackages';
import { WebGalleryAlbumCustomPrintFields } from '../../../../../../web-gallery/graphql/fragments/album';
import { VendorDetails } from '../../../../../../../graphql/fragments/account';

const albumMembershipGroupPurchaseDetails = gql`
  fragment albumMembershipGroupPurchaseDetails on AlbumMembershipGroup {
    id
    is_album
    album {
      id
      name
      album_type
      album_subtype
      creator {
        ...VendorDetails
      }
      photos_raw: photos {
        total
      }
      photos(use_all_photos_mode: true) {
        total
      }
      green_screen_enabled
      social_share_enabled
      hash_code
      display_public_photo_attribution
      search_subscription_credits_joins_enabled
      pre_paid: is_demo
      price_whole_album {
        value
        currency
      }
      root_album_folder {
        ...albumFolderDetails
        ...albumFolderPricing
        ...albumFolderCustomTags
        picture_day_enabled
        matching_disabled
        download_without_watermark
        pricing_categories {
          total
          records {
            id
            pricing_category {
              id
              name
            }
          }
        }
      }
      account_favorite_photos(slice: { limit: 9999 }) {
        total
        records {
          id
          photo {
            id
          }
        }
      }
      picture_day_enabled
      is_video_album
      ...WebGalleryAlbumCustomPrintFields
    }
    album_folder {
      ...albumFolderDetails
      ...albumFolderPricing
      ...albumFolderCustomTags
      picture_day_enabled
      matching_disabled
      has_album_photos
      download_without_watermark
      pricing_categories {
        total
        records {
          id
          pricing_category {
            id
            name
          }
        }
      }
      account_favorite_photos(slice: { limit: 9999 }) {
        total
        records {
          id
          photo {
            id
          }
        }
      }
    }
    album_custom_prints(
      slice: { limit: 99 }
      custom_print_types: [CUSTOM_PRINT]
      custom_print_subtype: null
      unique_custom_prints: true
    ) {
      total
      records {
        ...albumCustomPrintDetails
      }
    }
    account_card_album_custom_prints: album_custom_prints(
      slice: { limit: 99 }
      custom_print_types: [PRINT_PRODUCT]
      custom_print_subtype: null
      unique_custom_prints: true
    ) {
      total
      records {
        ...albumCustomPrintDetails
      }
    }
    collage_custom_prints: album_custom_prints(
      slice: { limit: 99 }
      custom_print_types: [PRINT_PRODUCT]
      custom_print_subtype: COLLAGE
      unique_custom_prints: true
    ) {
      total
      records {
        ...albumCustomPrintDetails
      }
    }
    specialty_custom_prints: album_custom_prints(
      slice: { limit: 99 }
      custom_print_types: [CUSTOM_PRINT]
      custom_print_subtype: SPECIALTY_PRINT
      unique_custom_prints: true
    ) {
      total
      records {
        ...albumCustomPrintDetails
      }
    }
    ...albumMembershipGroupPhotoPricing
    ...albumMembershipGroupPrintPackages
  }
  ${albumFolderDetails}
  ${albumFolderPricing}
  ${albumFolderCustomTags}
  ${albumCustomPrintDetails}
  ${albumMembershipGroupPhotoPricing}
  ${albumMembershipGroupPrintPackages}
  ${WebGalleryAlbumCustomPrintFields}
  ${VendorDetails}
`;

export default albumMembershipGroupPurchaseDetails;
